import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';
import classes from './Formik.module.scss';

const Form = (props) => {
  const { initialValues, validateValues, onSubmit, onReset, render, innerRef, ...rest } = props;

  const yupValidate = Yup.object().shape({
    ...validateValues,
  });
  const formEl = useRef(null);

  return (
    <div className={classes.wrapper}>
      <Formik
        initialValues={initialValues}
        validationSchema={yupValidate}
        enableReinitialize
        onSubmit={(values) => onSubmit(values)}
        onReset={(values) => onReset(values)}
        innerRef={innerRef || formEl}
        {...rest}>
        {(fmProps) => render(fmProps)}
      </Formik>
    </div>
  );
};

Form.defaultProps = {
  initialValues: {},
  validateValues: {},
  onSubmit: () => {},
  onReset: () => {},
  render: () => {},
  innerRef: null,
};

Form.propTypes = {
  initialValues: PropTypes.object,
  validateValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  render: PropTypes.func,
  innerRef: PropTypes.any,
};

export default Form;
